import { Card, Checkbox, Col, DatePicker, Form, Input, Radio, Row, Select, Table } from 'antd'
import { useEffect, useState } from 'react'
import moment from "moment";

import service from 'src/services/citizenScienceService'

import { citizenScienceStatusEnum } from "@seims/shared";

import { recordError } from "../../../utils/logService";

import { util } from '@seims/shared';

export default function ProjectDetails({ onSetNextStatus, formRef, data, props }) {

    const [scienceFields, setScienceFields] = useState([])
    const [scienceDomains, setScienceDomains] = useState([])

    const [checkedObjectiveList, setCheckedObjectiveList] = useState([]);
    const [checkedRoleList, setCheckedRoleList] = useState([]);
    const [showOtherObjective, setShowOtherObjective] = useState(false);
    const [showOtherRoles, setShowOtherRoles] = useState(false);

    const [current, setCurrent] = useState([]);

    const [projectObjectives, setProjectObjectives] = useState([]);
    const [selectedObjectives, setSelectedObjectives] = useState([]);

    const [projectDisseminations, setProjectDisseminations] = useState([]);
    const [selectedDisseminations, setSelectedDisseminations] = useState([]);

    const [selectedScienceShopInitiatives, setSelectedScinceShopInitiatives] = useState([]);

    const { TextArea } = Input;
    const formItemLayout = {
        labelCol: {
            span: 18,
        },
        wrapperCol: {
            span: 20,
        },
        layout: "vertical",
    };

    useEffect(() => {
        getScienceDomains();
        loadProjectDetails();
        getProjectObjectives();
        getProjectDisseminations();
    }, [])

    const { Option } = Select;
    const [form] = Form.useForm();
    const formName = "ProjectDetails";

    const loadProjectDetails = () => {
        if (!util.isEmpty(data)) {
            const locationObj = data.locations.map((domain) => domain.town?.toString() + ", " + domain.district.toString() + ", " + domain.province.toString())

            form.setFieldsValue({
                name: data.name,
                description: data.description,
                scienceField: data.scienceField.value,
                scienceDomains: data.scienceDomains.map(d => d.value).join(", "),
                // researchMethodologies: data.researchMethodologies,
                initiallyCitizenScience: data.initiallyCitizenScience,
                otherDissemination: data.otherDissemination,
                startDate: moment(data.startDate, 'YYYY-MM-DD HH:mm:ss'),
                endDate: moment(data.endDate, 'YYYY-MM-DD HH:mm:ss'),
                locations: locationObj,
                scienceShopInitiative: data.scienceShopInitiative
            })
            setSelectedObjectives(data.objectives)
            setSelectedDisseminations(data.dissemination)
            setSelectedScinceShopInitiatives(data.scinceShopInitiatives)

        }

    }
    const getScienceDomains = async () => {
        try {
            const response = await service.getScienceDomains();
            if (response && response.status === 200) {
                const { data } = response;
                setScienceDomains(data);
            }
        } catch (error) {
            recordError(error);
        }
    };
    const getProjectObjectives = async () => {
        try {
            const response = await service.getProjectObjectives();
            if (response && response.status === 200) {
                const { data } = response;
                setProjectObjectives(data);
            }
        } catch (error) {
            recordError(error);
        }
    };
    const getProjectDisseminations = async () => {
        try {
            const response = await service.getProjectDisseminations();
            if (response && response.status === 200) {
                const { data } = response;
                setProjectDisseminations(data);
            }
        } catch (error) {
            recordError(error);
        }
    };
    const onSubmit = (values) => {
        onNext(values)
        const start = moment(values.startDate).format("YYYY,MM,DD")
        const end = moment(values.endDate).format("YYYY,MM,DD")
        const projectObj = {
            "Project Title": values.projectTitle,
            "Science Field": values.scienceFields,
            "Science Domain": values.scienceDomain,
            "Research Methology": values.researchMethology,
            "Start Date": start,
            "End Date": end,
            "Project Location": values.location,
            "Description": values.description,
            "citizenScience": values.citizenScience,
            "Objectives": checkedObjectiveList,
            "project Roles": checkedRoleList
        }
        onSetNextStatus(citizenScienceStatusEnum.ORGANIZATIONS);

    };
    const onNext = async () => {
        try {
            await form.validateFields(['projectTitle', 'location'])
            setCurrent((prev) => prev + 1);
        } catch (error) {

        }
    }
    const onChangeScienceFields = (value) => {
    }
    const handleSelectedObjectives = (option) => {

        if (selectedObjectives.find(o => o.key === option.key)) {
            return true;
        } else {
            return false;
        }
    }
    const handleSelectedDisseminations = (option) => {
        // return (!!selectedDisseminations.find(o => o.key === option.key));
        return (selectedDisseminations.find(o => o.key === option.key)) ? true : false;
    }
    const columns = [
        {
            title: "Province",
            dataIndex: "province",
            key: "province",
            render: (record) => {
                return (
                    <>
                        {record.value}
                    </>
                );
            },
        },
        {
            title: "District",
            dataIndex: "district",
            key: "district",
            render: (record) => {
                return (
                    <>
                        {record.value}
                    </>
                );
            },
        },
        {
            title: "Nearest Town",
            dataIndex: "town",
            key: "town",
            render: (record) => {
                return (
                    <>
                        {record?.value}
                    </>
                );
            },
        }
    ];
    return (
        <div className='contentx'>
            <Form
                {...formItemLayout}
                name={formName}
                form={form}
                onFinish={onSubmit}
                scrollToFirstError
                initialValues={{ remember: true }}
                ref={formRef}
                disabled={true}
            >
                <Row>
                    <Col xs={24} sm={8} md={20}>
                        <Form.Item
                            name="name"
                            label="Title"
                            rules={[
                                {
                                    required: false,
                                    message: 'Please enter project title'
                                }
                            ]}
                        >
                            <Input
                                name="name"
                                showCount
                                maxLength={255}
                                minLength={3} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col xs={24} md={20}>
                        <Form.Item
                            name="description"
                            label="Description"
                        >
                            <TextArea
                                name="description"
                                showCount
                                maxLength={400}
                                minLength={5} nt
                                rows={4}
                                placeholder="Please add project description here..." />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col xs={24} sm={6} md={6}>
                        <Form.Item
                            name="scienceField"
                            label="Science Discipline"
                            rules={[
                                {
                                    required: false,
                                    message: "Please select science field",
                                },
                            ]}
                        >
                            <Select onChange={onChangeScienceFields} >
                                {scienceFields.map((field) => (
                                    <Option key={field.key} value={field.value}>{field.value}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={6} md={6}>
                        <Form.Item
                            name="scienceDomains"
                            label="Science Field(s)"
                            rules={[
                                {
                                    required: false,
                                    message: "Please select science domain"
                                }
                            ]}
                        >
                            {/* <Select onChange={onChangeScienceFields} >
                                {scienceDomains.map((domain) => (
                                    <Option key={domain.key}> value={domain.value}{domain.value}</Option>
                                ))}
                            </Select> */}
                            <TextArea name='scienceDomains' />
                        </Form.Item>
                    </Col>
                    {/* <Col xs={24} sm={6} md={6} key={"f-categories"}>
                        <Form.Item
                            name="researchMethodologies"
                            label="Research Methodology (Multi selection)"
                        >
                            <TreeSelect
                                onChange={handleMethodologyChange}
                                value={selectedMethodologies}
                                treeData={withAllSelector(
                                    selectedMethodologies,
                                    setSelectedMethodologies,
                                    methodologiesTData
                                )}
                                {...tProps}
                            />
                        </Form.Item>
                    </Col> */}
          </Row>
          <Row>
            <Col>
              <Form.Item
                name="startDate"
                label="Planned Start Date"
                rules={[
                  {
                    required: false,
                    message: "Please select date",
                  },
                ]}
              >
                <DatePicker />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="endDate"
                label="Planned End Date"
                rules={[
                  {
                    required: false,
                    message: "Please select date",
                  },
                ]}
              >
                <DatePicker />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={24} sm={8} md={20}>
              <Form.Item
                name="locations"
                label="Locations"
                rules={[
                  {
                    required: false,
                    message: "Please select Location values",
                  },
                ]}
              >
                <Table
                  dataSource={data.locations}
                  columns={columns}
                  rowKey={(record, index) => "row-" + index}
                  bordered
                  pagination={{ pageSize: 10 }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={8}>
              Was this project conceptualised as Citizen Science project from
              the beginning?
            </Col>
            <Col span={6}>
              <Form.Item name="initiallyCitizenScience">
                <Radio.Group value={data.initiallyCitizenScience}>
                  {data.initiallyCitizenScience === true ? (
                    <Radio value={true}>Yes</Radio>
                  ) : (
                    <Radio value={false}>No</Radio>
                  )}
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={8}>
              <Card
                title="Objectives"
                bordered={true}
                headStyle={{
                  border: 0,
                  textAlign: "left",
                  fontSize: 18,
                }}
              >
                <Row>
                  <Col>
                    <Form.Item name="objectives">
                      {projectObjectives.map((option, index) => (
                        <Row>
                          <Checkbox
                            key={index}
                            value={option.value}
                            checked={handleSelectedObjectives(option)}
                          >
                            {option.value}
                          </Checkbox>
                        </Row>
                      ))}
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col xs={24} md={8}>
              <Card
                title="Planned Research Dissemination Approach"
                bordered={true}
                headStyle={{
                  border: 0,
                  textAlign: "left",
                  fontSize: 18,
                }}
              >
                <Row>
                  <Col>
                    <Form.Item name="approach">
                      {projectDisseminations.map((option, index) => (
                        <Row>
                          <Checkbox
                            key={index}
                            value={option.value}
                            checked={handleSelectedDisseminations(option)}
                          >
                            {option.value}
                          </Checkbox>
                        </Row>
                      ))}
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              Is the facility at this institution a Science Shop?
            </Col>
            <Col span={6}>
              <Form.Item name="scienceShopInitiative">
                <Radio.Group value={data.scienceShopInitiative}>
                  {data.scienceShopInitiative === true ? (
                    <Radio value={true}>Yes</Radio>
                  ) : (
                    <Radio value={false}>No</Radio>
                  )}
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    );
}
